// Homepage loader timing (markup/CSS mechanics: resources/views/frontend/
// shared/page-loader.blade.php, resources/frontend/scss/components/
// _page-loader.scss). The inline script in the partial already decided
// (via localStorage) whether to show the block at all and set
// html.has-page-loader — this file only drives the two CSS-transition
// stages once the DOM is ready:
//   1. .is-filled  — triggers the ~1.5s text reveal + subtitle color
//      (the fixed .page-loader__overlay, matching its longest transition).
//   2. .is-collapsed — after the reveal finishes, fades the fixed overlay
//      out; removing html.has-page-loader at the same time slides
//      header/main/footer up from translateY(100vh) (transform, so no
//      layout shift).
import $ from 'jquery';

$(function () {
    const $loader = $('[data-page-loader]');

    if (!$loader.length || $loader.css('display') === 'none') {
        return;
    }

    // Matches the 1.5s background-position slide in _page-loader.scss.
    const FILL_DURATION = 1500;
    // Overlay fade (.4s) + page slide-up (.6s), see _page-loader.scss.
    const COLLAPSE_DURATION = 1000;

    // Force a reflow before adding the class so the browser commits the
    // unfilled state first and actually transitions from it — a plain
    // synchronous addClass() right after render could get coalesced into
    // the same style recalc as the initial paint (no transition would
    // play). requestAnimationFrame would also work in an active tab, but
    // gets throttled/skipped in a backgrounded one; this doesn't.
    void $loader[0].offsetHeight;
    $loader.addClass('is-filled');

    setTimeout(() => {
        $loader.addClass('is-collapsed');
        // Unlock scroll and start the page slide-up together with the
        // overlay fade (both hang off html.has-page-loader).
        $('html').removeClass('has-page-loader');
        localStorage.setItem('homepageLoaderShown', '1');
    }, FILL_DURATION);

    setTimeout(() => {
        $loader.remove();
    }, FILL_DURATION + COLLAPSE_DURATION);
});
